<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<p class="CT-RECTO">“Was the nail you stepped on rusty? You’ll get tetanus!”</p>
</div>
<p class="COT">The word “tetanus” comes from the Greek for “stretched tight,” because infection leads to muscle contractions and spasms throughout the body—at first in the jaw, which is why it’s also called “lockjaw.” During the last century, it became an article of faith among doctors and parents that puncture wounds involving rusty nails were a particularly dangerous form of transmission. Among the famous tetanus victims killed by an encounter with one fateful nail were British ornithologist George Montagu, silent-movie cowboy superstar Fred Thomson, and Robert E. Lee’s celebrated horse Traveller.</p>
<p class="TX">So I don’t want to downplay the danger of nails: yes, puncture wounds can lead to tetanus, so kids should be vaccinated and adults should get their booster shot every ten years like they’re supposed to. But the famous rusty nail is a red herring. Rust, of course, is just harmless iron oxide and doesn’t cause infectious disease. Tetanus is spread by a hardy little bug called <span class="txit">Clostridium tetani,</span> which survives outside the body in the form of hardy little spores, much like anthrax. These spores are everywhere, so any kind of wound, from a deep scratch to an animal bite, can potentially transmit tetanus. There’s nothing magical about the rusty nail, except that rusty nails are often dirty, and dirt can be full of tetanus spores. Hyping the rusty nail is dangerous: it may give parents a false sense of security when their little darling gets poked <a id="page_15">with something rust-free that may nonetheless be contaminated with tetanus.</a></p><a id="page_15">
<p class="TX">The good news is that tetanus is now very rare (except in the developing world, where its neonatal form is still a serious problem). There are fewer than a hundred U.S. cases every year, mostly involving people who let their shots lapse, and only one in ten turns fatal. I’d guess that the Rusty Nail cocktail (Drambuie and Scotch!) probably kills more people every year than actual rusty nails do.</p>
<p class="image"><img alt="Images" height="17" src="images/f0014-01.jpg" width="120"/></p>
<p class="TF">MOSTLY FALSE.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch09.vue?4a89b75a